import { IApplicationContext } from '../types/application';

export function isSearchOffersExperimentEnabled(context: IApplicationContext): boolean {
  return Boolean(
    context.custom.withSearch && context.config.get<boolean>('mobile-mainpage-frontend.searchOffers.enabled'),
  );
}
